module.exports = __webpack_public_path__ + "static/img/4299_phase_function_Paper_PointsHejduk_Prediction.5644c3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4299_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BOGw
// module chunks = 0